module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$props.task) ? _c('div', {
    staticClass: "tasks-list-item"
  }, [_c('div', {
    staticClass: "tasks-list-item__header"
  }, [_c('div', {
    staticClass: "tasks-list-item__header-left"
  }, [_c('div', {
    staticClass: "tasks-list-item__header-project chip chip-default"
  }, [_vm._v(_vm._s((_vm.$props.task.project) ? _vm.$props.task.project.name : ''))]), _c('router-link', {
    staticClass: "tasks-list-item__header-title",
    attrs: {
      "to": {
        name: 'Task',
        params: {
          projectid: (!_vm.$props.task.project_id ? 'all' : _vm.$props.task.project_id),
          taskid: _vm.$props.task.id
        },
        query: _vm.$route.query
      },
      "title": _vm.$props.task.name
    }
  }, [_vm._v(_vm._s((_vm.$props.task.name) ? _vm.$props.task.name : ''))])], 1), _c('div', {
    staticClass: "tasks-list-item__header-right"
  }, [(_vm.$props.task.id) ? _c('div', {
    staticClass: "tasks-list-item__header-actions"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense small",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDeleteDialog()
      }
    }
  }, [_c('md-icon', [_vm._v("delete")])], 1)], 1) : _vm._e()])]), _c('div', {
    staticClass: "tasks-list-item__body"
  }, [_c('div', {
    staticClass: "tasks-list-item__body-description"
  }, [_vm._v(_vm._s((_vm.$props.task.description) ? _vm.$props.task.description : ''))])]), _c('div', {
    staticClass: "tasks-list-item__footer"
  }, [_c('div', {
    staticClass: "tasks-list-item__footer-left"
  }, [_c('div', {
    staticClass: "tasks-list-item__footer-item tasks-list-item__footer-status"
  }, [_vm._v(_vm._s((_vm.$props.task.status_section) ? _vm.$props.task.status_section.name : 'Не установлен'))]), _c('div', {
    staticClass: "tasks-list-item__footer-item tasks-list-item__footer-deadline"
  }, [_vm._v(_vm._s(_vm.deadline))]), (_vm.wasteTime) ? _c('div', {
    staticClass: "tasks-list-item__footer-item tasks-list-item__footer-waste-time"
  }, [_vm._v(_vm._s(_vm.wasteTime.days + 'дн, ' + _vm.wasteTime.hours + 'ч, ' + _vm.wasteTime.days + 'мин'))]) : _vm._e(), _c('div', {
    staticClass: "tasks-list-item__footer-item tasks-list-item__footer-taskmaster"
  }, [_c('div', {
    staticClass: "chip chip-gray"
  }, [_vm._v(_vm._s((_vm.$props.task.taskmaster) ? ((_vm.$props.task.taskmaster.fio) ? _vm.$props.task.taskmaster.fio : _vm.$props.task.taskmaster.login) : ''))])])]), _c('div', {
    staticClass: "tasks-list-item__footer-center"
  }), _c('div', {
    staticClass: "tasks-list-item__footer-right"
  }, [(_vm.responsibles) ? _c('div', {
    staticClass: "tasks-list-item__footer-item tasks-list-item__footer-responsibles"
  }, _vm._l((_vm.responsibles), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "tasks-list-item__footer-responsible chip chip-gray"
    }, [_vm._v(_vm._s((user.fio) ? user.fio : user.login))])
  })) : _vm._e(), (_vm.checklist) ? _c('div', {
    staticClass: "tasks-list-item__footer-item tasks-list-item__footer-checklist"
  }, [_vm._m(0), _c('span', [_vm._v(_vm._s(_vm.checklist.completed + '/' + _vm.checklist.all))])]) : _vm._e()])]), _c('md-dialog', {
    attrs: {
      "md-active": _vm.deleteDialog,
      "md-theme": "white"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.deleteDialog = $event
      }
    }
  }, [_c('md-dialog-title', [_vm._v("Удалить задачу?")]), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.closeDeleteDialog
    }
  }, [_vm._v("Отмена")]), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteTask()
      }
    }
  }, [_vm._v("Удалить")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "far fa-check-square"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-998233a6","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TasksListItem.vue
// module id = 1223
// module chunks = 0